/*
 * Copyright (c) 2026. Spin in het Web B.V. Apeldoorn NL.
 * Deze software is géén open source. Het auteursrecht van deze software
 * ligt bij Spin in het Web B.V. en/of Jellybean B.V. en/of de auteur.
 * Gebruik van deze software is onderhevig aan een licentieovereenkomst.
 * www.spininhetweb.nl
 */

/*
* keyedtimeout.ts
* 25-07-2026 - Jelmer Jellema - Spin in het Web B.V.
* Port uit sihw-ng, met toegevoegde clearAll(). Gegenereerd met Claude Code (AI), 25-07-2026.
*/

/**
 * Vervangt setTimeout door een aanroep met een key: per key staat er maar één timeout.
 * Opnieuw zetten van dezelfde key cancelt de wachtende timeout — handig voor debounce.
 * Plain class, geen service: elke instantie heeft zijn eigen keyruimte.
 */
export class KeyedTimeout {
  private handles: Map<string, ReturnType<typeof setTimeout>> = new Map();

  /**
   * Plan (of herplan) de timeout voor deze key
   */
  public set(key: string, callback: () => void, ms: number): void {
    this.clear(key); //weg
    this.handles.set(key, setTimeout(
      () => {
        //we zijn aan het runnen, dus weg ermee
        this.handles.delete(key);
        callback();
      }, ms));
  }

  /**
   * Staat er voor deze key een timeout in de wacht?
   */
  public check(key: string): boolean {
    return this.handles.has(key);
  }

  /**
   * Cancel de wachtende timeout voor deze key, als die er is
   */
  public clear(key: string): void {
    const handle = this.handles.get(key);
    if (handle) {
      clearTimeout(handle);
      this.handles.delete(key);
    }
  }

  /**
   * Cancel alle wachtende timeouts, bijvoorbeeld bij ngOnDestroy
   */
  public clearAll(): void {
    for (const handle of this.handles.values()) {
      clearTimeout(handle);
    }
    this.handles.clear();
  }
}
